<div class="mct-flex mct-col mct-gap-10 mct-justify-center mct-items-start">
  <div class="mct-flex mct-col mct-gap-2 mct-justify-center mct-items-start">
    <label>{{ 'profiles.search.activity-type' | translate | titlecase }}</label>
    <p-select
      placeholder="{{ 'common.select' | translate | titlecase }}"
      [options]="memberActivityTypes"
      [style]="{ width: '100%' }"
      [(ngModel)]="selectedActivityId"
      appendTo="body"
      (onChange)="onFieldChange()"
    >
    </p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-2 mct-justify-center mct-items-start">
    <label>{{ 'profiles.search.activity-date' | translate | titlecase }}</label>
    <wl-date-selector
      ngDefaultControl
      name="activityDate"
      [(ngModel)]="activityDate"
      appendTo="body"
      (onDateChanged)="onFieldChange()"
    ></wl-date-selector>
  </div>
</div>
